import { LogisticsChangeLog } from '@/api/apis/route';
import { useScrollToAnchor } from '@/hooks/useScrollToAnchor';
import { ChangeLogItem } from './ChangeLogItem';

type ChangeLogListProps = {
  logs: LogisticsChangeLog[];
};

export const ChangeLogList = ({ logs }: ChangeLogListProps) => {
  useScrollToAnchor();

  return (
    <div className="flex flex-col-reverse h-full min-h-0 overflow-y-auto">
      <div className="flex flex-col gap-4">
        {logs.map((log) => (
          <ChangeLogItem key={log.id} log={log} />
        ))}
      </div>
    </div>
  );
};
